import axios from 'axios';
import { useAuth } from './AuthContext';
import { EMPLOYEE_API_BASE_URL } from './Api';

const UseAxios = () => {
    const { token, logout } = useAuth(); // ✅ get logout here

    const instance = axios.create({
        baseURL: EMPLOYEE_API_BASE_URL,
    });

    instance.interceptors.request.use((config) => {
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    instance.interceptors.response.use(
        response => response,
        error => {
            if (error.response?.status === 401) {
                console.log("🚫 401 detected. Auto logout.");
                logout(); // ✅ SAFE
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

export default UseAxios;
